import { theme } from "antd";
import { useContext, useState } from "react";
import { SmartMenuContext } from "@/config/context/smartMenuContext";
import { SmartSelectContact } from "@/components/smart-select-contacts";

export const StoresUserPermissionsCreate: React.FC<{
  t?: any;
  onClose?: () => void;
  refetch?: () => void;
  sectionType?: "permission" | "contact";
}> = ({ t, onClose, refetch, sectionType }) => {
  const { smartMenuName, smartMenuLabel } = useContext(SmartMenuContext);
  const sellerCode = encodeURIComponent(
    smartMenuName?.replace(/"/g, "").toLowerCase(),
  );

  const handleCancel = () => {
    onClose?.();
  };

  return (
    <SmartSelectContact
      handleCancel={handleCancel}
      onSaveContact={async (data: any) => {
        console.log("Contact saved:");
      }}
      store={{
        code: sellerCode,
        name: smartMenuLabel || smartMenuName,
        link: "store",
      }}
      layout="modal"
      refetch={refetch}
      sectionType={sectionType}
    />
  );
};
